import { createRoot, hydrateRoot } from 'react-dom/client';

import App from './App';

import './index.css';

const root = document.getElementById('root')!;

// In produzione le pagine sono pre-renderizzate (SSG): React "idrata" l'HTML
// esistente riusandolo, senza sostituirlo (niente flash). In dev, o se il
// root è vuoto, si parte da zero come prima.
if (root.hasChildNodes()) {
  hydrateRoot(root, <App />);
} else {
  createRoot(root).render(<App />);
}
